import { Box, Flex } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import { ColorGroup } from './ColorGroup/colorGroup';
import ZoomGameMockUp from '../../ZoomGameMockUp/zoomGameMockUp';

export const SetColors = () => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setColors.label')} description={t('form.steps.setColors.description')}>
					{t('form.steps.setColors.heading')}
				</FormSectionHeading>
				<ColorGroup />
				
			</LeftColumn>
			<RightColumn>
				<ZoomGameMockUp
					ctaColor={(values as any).colors.actionColor}
					textColor={(values as any).colors.textColor}
					bgColor={(values as any).colors.backgroundColor}
					name={(values as any).name}
					video={(values as any).video}
					screenshots={(values as any).screenshots}
				/>
			</RightColumn>
		</TwoColumn>
	);
};
